module.exports = __webpack_public_path__ + "static/media/info.97bacbce.svg";